import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

import Box from 'shopper/components/Box';
import Text from 'shopper/components/Text';

import AdSenseSlot, { AD_SLOTS } from 'components/AdSlots/AdSenseSlot';

import placeholder from 'lib/placeholder';

const SidebarGoogleAd = forwardRef(
  (
    { showAdSlotOnBreakpoints = [false, null, null, true], className, ...rest },
    ref
  ) => (
    <Box
      ref={ref}
      className={twMerge(
        'hidden h-[300px] flex-col items-center xl:flex',
        className
      )}
      {...rest}
    >
      <Text
        className="hidden px-6 py-4 text-neutral-high-500 dark:text-neutral-high-500 xl:block"
        size="size3"
      >
        {placeholder('titles.paidMedia')}
      </Text>
      <AdSenseSlot
        height={250}
        showAdSlotOnBreakpoints={showAdSlotOnBreakpoints}
        slotId={AD_SLOTS.SIDEBAR_300x250}
        width={300}
      />
    </Box>
  )
);

SidebarGoogleAd.displayName = 'SidebarGoogleAd';

SidebarGoogleAd.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  showAdSlotOnBreakpoints: PropTypes.arrayOf(PropTypes.bool),
};

export default SidebarGoogleAd;
